import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  submitForm(event) {
    const formId = event.params.formId
    const form = document.getElementById(formId)
    if (form) form.requestSubmit()
  }
}
